module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_6_5.6f81cabd.png";